import { getFinalReadOnlyMode } from "Areas/Documents/documentDetails/redux/getReadOnlyMode";
import graphActionCreators from "Areas/Documents/graph/redux/actionCreators";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import withPopupMessage from "Components/withPopupMessage";
import filter from "lodash/filter";
import flatMap from "lodash/flatMap";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import pick from "lodash/pick";
import uniq from "lodash/uniq";
import values from "lodash/values";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import actionCreators from "../redux/actionCreators";
import { getActiveDocumentId, getActiveDocumentType, getAvailableMethodsMap, getIsExpanded, getMethods, getObjects, getSelectedNodesSource, getTabMethodsInProgress } from "../redux/selectors";
import TabMethods from "./tabMethods";
const getAvailableMethods = createSelector((state) => getMethods(state), (state) => getObjects(state), (state) => getSelectedNodesSource(state), (methods, documentObjects, selectedNodesSource) => {
    if (!methods || !documentObjects)
        return undefined;
    if (isEmpty(methods) || isEmpty(documentObjects) || isEmpty(selectedNodesSource))
        return [];
    const availableDocumentObjectId = uniq(map(selectedNodesSource, "DocumentObjectId"));
    const availableMethodIds = flatMap(values(pick(documentObjects, availableDocumentObjectId)), "AvailableMethods");
    return filter(methods, e => includes(availableMethodIds, e.Id));
});
const canRunMethods = security.isAllowed([Permissions.MethodsRun]);
const mapStateToProps = (state) => ({
    isExpanded: getIsExpanded(state),
    activeDocumentId: getActiveDocumentId(state),
    activeDocumentType: getActiveDocumentType(state),
    inProgress: getTabMethodsInProgress(state),
    documentObjects: getObjects(state),
    availableMethods: getAvailableMethods(state),
    availableMethodsMap: getAvailableMethodsMap(state),
    selectedNodesSource: getSelectedNodesSource(state),
    canRunMethods,
    readOnlyMode: getFinalReadOnlyMode(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(actionCreators.getMethods());
        dispatch(actionCreators.getObjects());
    },
    onSetMethodSelected: (method, nodesSource, selected) => dispatch(actionCreators.toggleMethodSelected(method, nodesSource, selected)),
    onRunMethods: (documentId, activeDocumentType, data) => {
        const action = actionCreators.runMethods(documentId, data);
        if (action) {
            if (activeDocumentType === DOCUMENT_TYPE.GRAPH) {
                dispatch(graphActionCreators.setSaveTriggered(documentId, true));
            }
            dispatch(action);
        }
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(withPopupMessage(TabMethods));
